import { render, staticRenderFns } from "./_edit-delivery.modal.vue?vue&type=template&id=4b66b7cb"
import script from "./_edit-delivery.modal.vue?vue&type=script&lang=js"
export * from "./_edit-delivery.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports